import { postSendPersistKey } from '../../../../services/modal-services'
import { useModalWelcomeWiggotStore } from '../../../../store/modals-services/modal-welcome-wiggot'
import { ROUTES } from '../../../../constants'

export const useWelcomeWiggot = () => {
  const isOpen = useModalWelcomeWiggotStore((state) => state.isOpen)
  const setIsOpenWelcomeWiggot = useModalWelcomeWiggotStore(
    (state) => state.setIsOpen
  )

  const onClose = () => {
    setIsOpenWelcomeWiggot({
      isOpen: false
    })
  }

  const goToShop = () => {
    window.open(ROUTES.SHOP)
  }

  const handleActiveTrialPlan = () => {
    postSendPersistKey({
      key: 'NEW_WIGGOT_USER',
      value: true
    })
    onClose()
  }
  return {
    handleActiveTrialPlan,
    isOpen,
    onClose,
    goToShop
  }
}
